"use strict";
/*
  This file is part of web3x.

  web3x is free software: you can redistribute it and/or modify
  it under the terms of the GNU Lesser General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  web3x is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Lesser General Public License for more details.

  You should have received a copy of the GNU Lesser General Public License
  along with web3x.  If not, see <http://www.gnu.org/licenses/>.
*/

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var bn_js_1 = tslib_1.__importDefault(require("bn.js"));

var bn_1 = require("./bn");
/**
 * Converts value to it's number representation
 *
 * @method hexToNumber
 * @param {String|Number|BN} value
 * @return {String}
 */


function hexToNumber(value) {
  return bn_1.toBN(value).toNumber();
}

exports.hexToNumber = hexToNumber;
/**
 * Converts value to it's decimal representation in string
 *
 * @method hexToNumberString
 * @param {String|Number|BN} value
 * @return {String}
 */

function hexToNumberString(value) {
  return bn_1.toBN(value).toString(10);
}

exports.hexToNumberString = hexToNumberString;
/**
 * Converts value to it's hex representation
 *
 * @method numberToHex
 * @param {String|Number|BN} value
 * @return {String}
 */

function numberToHex(value) {
  var num = bn_1.toBN(value);
  var result = num.toString(16);
  return num.lt(new bn_js_1.default(0)) ? '-0x' + result.substr(1) : '0x' + result;
}

exports.numberToHex = numberToHex;